import React, { useEffect, useState } from 'react';
import qs from 'qs';
import MuiTable from '../../../components/MuiTable/MuiTable';
import Button from '../../../components/Button/Button';
import SearchInput from '../../../components/SearchInput/SearchInput';
import { colors, markedDmcaCountLables } from '../../../config/constants';
import {
  updateFlashBar,
  updateIsLoading,
  updateReviewTab,
} from '../../../redux/action';
import instance from '../../../service/axiosInstane';
import { useDispatch, useSelector } from 'react-redux';
import { flashBarTheme } from '../../../config/flashBar';
import { SortOrderType } from '../../../config/enum';
import { StateProps } from '../../../redux/reducer';
import Filter from '../../../components/Filter/Filter';
import {
  errorMessageAutoCapitalize,
  handlingMoreCharactor,
  totalPages,
} from '../../../config/helpers';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Dailog from '../../../components/Dailog/Dailog';
import EllipsisHanlder from '../../../components/Ellipsis/EllipsisHanlder';

const columnsKeyword = [
  { id: 'keywordText', label: 'Keyword', minWidth: 600, align: 'left' },
  { id: 'hitCount', label: 'Hit Count', minWidth: 100, align: 'center' },
  { id: 'isReviewed', label: 'Reviewed', minWidth: 100, align: 'center' },
  { id: 'keywordAction', label: 'Action', minWidth: 0, align: 'right' },
];

type rootFilterProps = {
  name: string;
  value: string | boolean | null;
};

type ReviewKeywordProps = {
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  results?: ResultProps[];
};

type ResultProps = {
  id: string;
  isReviewed: boolean;
  keywordId: string;
  keywordText: string;
  hitCount: number;
};

type ReviewStateProps = {
  categoryId: string;
  categoryIdName: string;
  categoryLabelId: string;
  categoryLabelName: string;
  organizationId: string;
  reviewStatus: number;
  siteHost: string;
  siteId: string;
  siteOrganizationId: string;
  siteOrganizationIndexId: string;
  siteUrl: string;
  totalDmcaMarked: number;
  totalIgnoredMarked: number;
  totalRevisitedMarked: number;
};

type KeywordRequestProps = {
  IsReviewed: null | boolean;
  Page: number;
  PageSize: number;
  SearchText: string;
  SortBy: string;
  SortOrder: string;
  CategoryLabel: string;
};

type CategoryStateProps = {
  name: string;
  value: string | boolean | null;
};

type ReviewCategoriesProps = {
  categoryId: string;
  categoryLabelId: string;
  categoryLabelName: string;
  categoryName: string;
  hitCount: number;
  keywordCount: number;
  reviewPercentage: number;
};

const rootFilter: rootFilterProps[] = [
  {
    name: 'All',
    value: null,
  },
  {
    name: 'Reviewed',
    value: true,
  },
  {
    name: 'Not Reviewed',
    value: false,
  },
];

const WebsiteKeyword = () => {
  const dispatch = useDispatch();
  const reviewTab = useSelector((state: StateProps) => state.reviewTab);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [reviewState, setReviewState] = useState<ReviewStateProps>({
    categoryId: '',
    categoryIdName: '',
    categoryLabelId: '',
    categoryLabelName: '',
    organizationId: '',
    reviewStatus: 0,
    siteHost: '',
    siteId: '',
    siteOrganizationId: '',
    siteOrganizationIndexId: '',
    siteUrl: '',
    totalDmcaMarked: 0,
    totalIgnoredMarked: 0,
    totalRevisitedMarked: 0,
  });
  const [keywordRequest, setKeywordRequest] = useState<KeywordRequestProps>({
    IsReviewed: null,
    Page: page,
    PageSize: limit,
    SearchText: '',
    SortBy: 'hitCount',
    SortOrder: SortOrderType.ASC,
    CategoryLabel: '',
  });
  const [keywordState, setKeywordState] = useState<ResultProps[]>([]);
  const [categoryState, setCategoryState] = useState<CategoryStateProps[]>([
    { name: '', value: '' },
  ]);
  const [categoryTotalCount, setCategoryTotalCount] = useState<any>();
  const [categoryRequest, setCategoryRequest] = useState({
    CategoryLabel: [],
    Page: 1,
    PageSize: 20,
    SearchText: '',
    SortBy: '',
    SortOrder: SortOrderType.ASC,
    ExcludeDisabled: true,
  });
  const [formErrors, setFormErrors] = useState<any>({});
  const [showCategory, setShowCategory] = useState<boolean>(false);
  const [catgoryLoading, setCategoryLoading] = useState(false);
  const [isDeletePopup, setIsDeletePopup] = useState(false);

  useEffect(() => {
    getReviewKeyword(keywordRequest);
    getSiteOrgReview();
    getReviewCategories(categoryRequest);
  }, [reviewTab]);

  useEffect(() => {
    const handler = setTimeout(() => {
      getReviewCategories(categoryRequest);
    }, 1000);
    return () => {
      clearTimeout(handler);
    };
  }, [categoryRequest.SearchText]);

  const viewRecordKeyword = (row: ResultProps) => {
    dispatch(
      updateReviewTab({
        ...reviewTab,
        tabName: 'searchResult',
        siteOrgIndexID: reviewTab.siteOrgIndexID,
        categoryID: reviewTab.categoryID,
        keywordID: row.id,
      })
    );
  };

  const getSiteOrgReview = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .get(
        `site-review/site-organization-index/${reviewTab.siteOrgIndexID}/review/categories/${reviewTab.categoryID}`
      )
      .then((response) => {
        if (response.status === 200) {
          setReviewState(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const getReviewKeyword = async (obj: KeywordRequestProps) => {
    dispatch(updateIsLoading(true));
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url = `site-review/site-organization-index/${reviewTab.siteOrgIndexID}/categories/${reviewTab.categoryID}/keywords?${queryString}`;
    await instance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        setKeywordState([]);
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const gotResponse = (data: ReviewKeywordProps) => {
    setKeywordState(data?.results as ResultProps[]);
    setTotalRowCount(data.totalCount);
    dispatch(updateIsLoading(false));
  };

  const searchHandler = () => {
    getReviewKeyword({
      ...keywordRequest,
      SearchText: keywordRequest.SearchText,
      PageSize: limit,
    });
  };

  const onSearchHandler = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setKeywordRequest({ ...keywordRequest, SearchText: e.target.value });
  };

  const handleEnterKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchHandler();
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      getReviewCategories({
        ...categoryRequest,
        SearchText: categoryRequest.SearchText,
      });
    }
  };

  const onClearSearch = () => {
    setKeywordRequest({
      ...keywordRequest,
      SearchText: '',
      Page: page,
      PageSize: limit,
    });
    getReviewKeyword({
      ...keywordRequest,
      SearchText: '',
      Page: page,
      PageSize: limit,
    });
  };

  const filterHandler = (row: rootFilterProps) => {
    getReviewKeyword({
      ...keywordRequest,
      IsReviewed: row.value as boolean,
      Page: page,
      PageSize: limit,
    });
    setKeywordRequest({ ...keywordRequest, IsReviewed: row.value as boolean });
  };

  const paginateHandler = {
    onClickPageNumber: (page: number) => {
      getReviewKeyword({ ...keywordRequest, Page: page, PageSize: limit });
      setPage(page);
    },
    onNextClick: () => {
      if (page < totalPages(totalRowCount, limit)) {
        getReviewKeyword({
          ...keywordRequest,
          Page: page + 1,
          PageSize: limit,
          CategoryLabel: keywordRequest.CategoryLabel,
        });

        setPage(page + 1);
      }
    },
    onPrevClick: () => {
      if (page > 1) {
        getReviewKeyword({
          ...keywordRequest,
          Page: page - 1,
          PageSize: limit,
          CategoryLabel: keywordRequest.CategoryLabel,
        });
        setPage(page - 1);
      }
    },
    onFirstClick: () => {
      if (page !== 1) {
        getReviewKeyword({
          ...keywordRequest,
          Page: 1,
          PageSize: limit,
          CategoryLabel: keywordRequest.CategoryLabel,
        });
        setPage(1);
      }
    },
    onLastClick: () => {
      if (page !== totalPages(totalRowCount, limit)) {
        getReviewKeyword({
          ...keywordRequest,
          Page: totalPages(totalRowCount, limit),
          PageSize: limit,
          CategoryLabel: keywordRequest.CategoryLabel,
        });
        setPage(totalPages(totalRowCount, limit));
      }
    },
    limitHandler: (item: number) => {
      getReviewKeyword({
        ...keywordRequest,
        Page: 1,
        PageSize: item,
        CategoryLabel: keywordRequest.CategoryLabel,
      });
      setLimit(item);
      setPage(1);
    },
  };

  const getReviewCategories = async (obj: any) => {
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url = `site-review/site-organization-index/${reviewTab.siteOrgIndexID}/categories?${queryString}`;
    await instance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.results !== null) {
            setCategoryState(
              response.data.results.map((n: ReviewCategoriesProps) => {
                return {
                  name: n.categoryName,
                  value: n.categoryId,
                };
              })
            );
          } else {
            setCategoryState([]);
          }

          setCategoryTotalCount(response?.data?.totalCount);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        setCategoryLoading(false);
        dispatch(updateIsLoading(false));
      });
  };

  const reviewDone = () => {
    dispatch(updateIsLoading(true));
    instance
      .put(
        `/site-review/site-organization-index/${reviewTab.siteOrgIndexID}/review/categories/${reviewTab.categoryID}`
      )
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: 'Reviewed successfully!',
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateReviewTab({
                                ...reviewTab,
                                tabName: 'category',
                                siteOrgIndexID: reviewTab.siteOrgIndexID,
                                categoryID: reviewTab.categoryID,
                                keywordID: reviewTab.keywordID,
                              }));
          getSiteOrgReview();
          getReviewKeyword({
            ...keywordRequest,
            Page: 1,
            PageSize: limit,
            CategoryLabel: keywordRequest.CategoryLabel,
          });
          setIsDeletePopup(false);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const loadMore = () => {
    getReviewCategories({
      ...categoryRequest,
      PageSize: categoryRequest.PageSize + 20,
      Page: 1,
    });
    setCategoryRequest({
      ...categoryRequest,
      PageSize: categoryRequest.PageSize + 5,
      Page: 1,
    });
  };

  const onClickCategory = (row: any) => {
    setShowCategory(false);
    dispatch(
      updateReviewTab({
        ...reviewTab,
        categoryID: row.value as string,
      })
    );
    setCategoryRequest({ ...categoryRequest, SearchText: '' });

    if (reviewTab.siteOrgIndexID !== '' || row.categoryID !== '') {
      setFormErrors({ ...formErrors, siteOrgIndexID: undefined });
    } else {
      setFormErrors({
        ...formErrors,
        siteOrgIndexID: `Category required!`,
      });
    }
  };

  const onSearchHanlder = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setCategoryRequest({ ...categoryRequest, SearchText: event.target.value });
    if (event.target.value !== '') {
      setFormErrors({ ...formErrors, searchKeyword: undefined });
    } else {
      setFormErrors({
        ...formErrors,
        [event.target.name]: `${errorMessageAutoCapitalize(
          event.target.name
        )} is required`,
      });
    }
  };

  return (
    <>
      <div className="px-2">
        <div className="text-black p-2 ">
          <div className="w-full sm:flex space-x-20 justify-between text-sm">
            <div className="flex items-center space-x-4 mb-3">
              <div>Website </div>
              <a
                target="_blank"
                rel="noreferrer"
                href={`${reviewState.siteUrl}`}
                className="text-blue-500 cursor-pointer"
              >
                : {reviewState.siteHost}
              </a>
            </div>
          </div>
          <div className="md:flex justify-between">
            <div className=" mb-3 text-sm">
              <EllipsisHanlder
                word={reviewState.categoryIdName}
                NoOfChar={20}
                label={'Category'}
              />
            </div>

            <div className="flex items-center space-x-2 text-sm">
              <div>Review Status </div>
              <div className="mt-1 flex items-center space-x-2">
                <div className="h-4 w-[100px] border rounded-sm">
                  <div
                    style={{ width: `${reviewState.reviewStatus}px` }}
                    className={`h-4 bg-green-600 rounded-sm`}
                  ></div>
                </div>
              </div>
              <div>{Math.round(reviewState.reviewStatus)}% </div>
            </div>
            {Math.round(reviewState.reviewStatus) < 100 && (
              <div className="mt-2 md:mt-0">
                <Button
                  label={'Review Done'}
                  type={'button'}
                  buttonType={'primary'}
                  onClick={() => setIsDeletePopup(true)}
                />
              </div>
            )}
          </div>
        </div>
        <div className="lg:flex items-center lg:space-x-4 mb-2">
          <div className="w-[200px] border border-red-400 text-center sm:flex items-center justify-between rounded-md shadow-sm  mt-2">
            <div className="text-[16px]  text-[#1b2e49] px-4">
              {reviewState.totalDmcaMarked}
            </div>
            <div className="text-sm  bg-red-400 w-full text-white p-1 text-center sm:rounded-b-sm md:rounded-r-sm">
              {markedDmcaCountLables.markedDMCA}
            </div>
          </div>

          <div className="w-[200px] border border-yellow-400 text-center sm:flex items-center justify-between  rounded-md shadow-sm  mt-2">
            <div className="text-[16px] text-[#1b2e49] px-4">
              {reviewState.totalRevisitedMarked}
            </div>
            <div className="text-sm  bg-yellow-400 w-full text-white p-1 text-center sm:rounded-b-sm md:rounded-r-sm">
              {markedDmcaCountLables.markedRevisit}
            </div>
          </div>

          <div className="w-[200px] border border-green-400 text-center sm:flex items-center justify-between rounded-md shadow-sm  mt-2">
            <div className="text-[16px]  text-[#1b2e49] px-4">
              {reviewState.totalIgnoredMarked}
            </div>
            <div className="text-sm bg-green-400 w-full text-white p-1 text-center sm:rounded-b-sm md:rounded-r-sm">
              {markedDmcaCountLables.ignored}
            </div>
          </div>
        </div>

        <div className="mt-1 py-1 w-full ">
          <div className="w-full bg-slate-50 rounded-md border p-2">
            <div className="xl:flex items-center justify-between">
              <div className={`font-semibold text-[18px] ${colors.primaryText}`}>
                Keyword Management
              </div>
              <div>
                <SearchInput
                  value={keywordRequest.SearchText}
                  onChange={onSearchHandler}
                  onSearch={searchHandler}
                  onClear={() => onClearSearch()}
                  handleEnterKeyPress={handleEnterKeyPress}
                />{' '}
              </div>
            </div>
            <div className="xl:flex items-center justify-between">
              <div className="xl:mt-0 mt-2">
                <div className="relative flex w-full md:w-auto">
                  <div className="w-full">
                    <div className={`text-sm mb-1 ${colors.primaryText} pl-2`}>
                      Categories
                    </div>
                    <div
                      onClick={() => setShowCategory(true)}
                      className="h-8 sm:w-[300px] w-full bg-white border flex items-center relative outline-none pr-[60px] pl-4 text-sm rounded-sm focus:border-[#64CCC5] cursor-pointer"
                    >
                      {reviewState.categoryIdName === '' ? (
                        <div className="text-gray-400">
                          {'Please select website'}
                        </div>
                      ) : reviewState.categoryIdName.length > 30 ? (
                        reviewState.categoryIdName.substring(0, 29) + '...'
                      ) : (
                        reviewState.categoryIdName
                      )}
                    </div>
                    <div className="text-[red] text-sm pl-2 mt-1">
                      {formErrors.siteOrgIndexID}
                    </div>
                  </div>

                  {showCategory && (
                    <ClickAwayListener
                      onClickAway={() => {
                        setShowCategory(false);
                        getReviewCategories({
                          ...categoryRequest,
                          SearchText: '',
                          PageSize: 5,
                          Page: 1,
                        });
                        setCategoryRequest({
                          ...categoryRequest,
                          SearchText: '',
                          PageSize: 5,
                          Page: 1,
                        });
                      }}
                    >
                      <div
                        style={{
                          maxHeight: '300px',
                          overflow: 'auto',
                          border: '1px solid #ccc',
                        }}
                        className="bg-white absolute top-14 text-sm shadow-lg sm:w-[300px] max-h-[200px] w-full overflow-scroll z-[10] p-2 rounded-md"
                      >
                        <div className="relative">
                          <input
                            className="h-6 w-full border relative outline-none pr-[60px] pl-4 text-sm rounded-sm focus:border-[#64CCC5]"
                            placeholder={'Please search text'}
                            value={categoryRequest.SearchText}
                            onChange={(
                              e: React.ChangeEvent<
                                HTMLInputElement | HTMLSelectElement
                              >
                            ) => onSearchHanlder(e)}
                            name={'searchKeyword'}
                            onKeyDown={handleKeyPress}
                            autoComplete="off"
                          />
                          <div
                            className="absolute top-[2px] right-3 cursor-pointer text-gray-600"
                            onClick={() =>
                              setCategoryRequest({
                                ...categoryRequest,
                                SearchText: '',
                              })
                            }
                          >
                            <i className="fa-solid fa-xmark"></i>
                          </div>
                        </div>
                        {catgoryLoading ? (
                          <div>Loading...</div>
                        ) : (
                          <div>
                            {categoryState?.length > 0 ? (
                              <div>
                                {categoryState?.map((item: any, index: number) => {
                                  return (
                                    <div
                                      key={index}
                                      className={`mt-2 cursor-pointer p-1 hover:bg-slate-200 ${
                                        categoryState.length !== index + 1 &&
                                        'border-b'
                                      }`}
                                      onClick={() => onClickCategory(item)}
                                    >
                                      <div
                                        className={`text-sm ${colors.primaryText}`}
                                      >
                                        {item.name}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              <div>No results found!</div>
                            )}
                            {categoryTotalCount >= categoryRequest.PageSize &&
                              categoryState?.length > 0 && (
                                <div
                                  className={`shadow-sm cursor-pointer mt-2 p-1 border border-sky-500 flex items-center justify-center text-sky-500`}
                                  onClick={() => loadMore()}
                                >
                                  Load More
                                </div>
                              )}
                          </div>
                        )}
                      </div>
                    </ClickAwayListener>
                  )}
                </div>
              </div>
              <div className="xl:mt-0 mt-2">
                <Filter
                  filterHandler={filterHandler}
                  rootFilter={rootFilter}
                  label={'Please select'}
                />
              </div>
            </div>

            <div className="mt-2 ">
              <MuiTable
                columns={columnsKeyword}
                rows={keywordState}
                showView={true}
                onViewHandler={viewRecordKeyword}
                page={page}
                limit={limit}
                paginateHandler={paginateHandler}
                totalRowCount={totalRowCount}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center pt-8">
        <Dailog
          isDeletePopup={isDeletePopup}
          setIsPopupOpen={setIsDeletePopup}
          type="reviewed"
          title={
            'All the keywords under this category will be marked as reviewed. Are you sure you want to proceed?'
          }
          onConfirm={() => {
            reviewDone();
          }}
        />
      </div>
    </>
  );
};

export default WebsiteKeyword;
